import * as z from "zod";

export const getCustomEventNames = {
  name: "getCustomEventNames" as const,
  description:
    "Custom event names this store has actually sent. A custom-event condition's eventName must come from here.",
  mutates: false,
  input: z.object({}),
  output: z.object({ eventNames: z.array(z.string()) }),
};
